import { http } from "helpers/Http";
import { IProfileUpdateParams } from "types/Profile";

export async function postEditProfile(params: IProfileUpdateParams): Promise<any> {
    const url = `users/profile/update`;
    const data = http.post(url, params).then((response) => response.data);
    return data;
}
